/* eslint-disable no-unused-vars */
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useAuth } from '../../authentication';
import { Text, H2, Button, Icon } from '../../../components';
import { InviteUserModal } from '../components';
import { UsersTable } from '../components/organisms';
import { usePortal } from '../../../providers';

import { useUsers, useRoles } from '../providers';

const UsersPageInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`;

const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const UsersContainer = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
`;

const Users = () => {
  const { users, createUser, deleteUser, updateUserEntitlement } = useUsers();
  const { roles } = useRoles();
  const auth = useAuth();
  const { showPortal } = usePortal();
  const usedEmailsList = [...users.map((i) => i.email)] || [];

  const currentUserRole = useMemo(
    () =>
      users.filter((i) => i.auth0Id === auth.user.sub)[0].memberships?.[0]?.entitlements?.[0]?.role
        .name,
    [users, auth.user.sub]
  );

  const onSubmit = async (data) => {
    try {
      const promises = data.user.map((user) =>
        createUser({
          ...user,
          email: user.email.toLowerCase()
        })
      );
      await Promise.all(promises);
    } catch (error) {
      const {
        response: {
          // eslint-disable-next-line no-unused-vars
          data: { errors }
        }
      } = error;
      // Handle errors from backend
    }
  };

  const handleInvitePeople = () => {
    showPortal(
      <InviteUserModal onSubmit={onSubmit} roles={roles} usedEmailsList={usedEmailsList} />
    );
  };

  return (
    <UsersContainer>
      <UsersPageInfoContainer>
        <FlexContainer>
          <H2>People</H2>
          <Text>
            {`Manage your organization's team members and their access permissions. Add new users,
              assign roles, and control what features and data each person can `}
            <br />
            {`access across your organization's workspace.`}
          </Text>
        </FlexContainer>
        <Button primary onClick={handleInvitePeople}>
          <Icon name='plus' displaySize={20} />
          Invite people
        </Button>
      </UsersPageInfoContainer>
      {users?.length > 0 ? (
        <UsersTable
          currentUserRole={currentUserRole}
          onDeleteUser={deleteUser}
          onUpdateUserEntitlement={updateUserEntitlement}
          users={users}
          isSameUser={(id) => id === auth.user.sub}
          roles={roles}
        />
      ) : (
        <Text>
          You have no users. Invite users by clicking the &quot;Invite people&quot; button above
        </Text>
      )}
    </UsersContainer>
  );
};

export { Users };
